import debug from 'debug'
import { getAirshipConfiguration } from '../../parameters'
import ScriptLoader from '../utils/ScriptLoader'

const d = debug('push:airship')

const airshipVariable = 'UA' // UA = Airship - https://docs.airship.com/reference/libraries/web-notify-sdk/latest/index.html

export const loadPushLibrary = () => {
  const { validPublicKey, appKey, token } = getAirshipConfiguration()
  return Promise.resolve()
    .then(() =>
      ScriptLoader.loadInlineJS(
        'airship',
        `!function(n,r,e,t,c){var i,o="Promise"in n,u={then:function(){return u},catch:function(n){
return n(new Error("Airship SDK Error: Unsupported browser")),u}},s=o?new Promise((function(n,r){i=function(e,t){e?r(e):n(t)}})):u
;s._async_setup=function(n){if(o)try{i(null,n(c))}catch(n){i(n)}},n[t]=s;var a=r.createElement("script");a.src=e,a.async=!0,a.id="_uasdk",
a.rel=t,r.head.appendChild(a)}(window,document,'https://aswpsdkeu.com/notify/v1/ua-sdk.min.js',
'${airshipVariable}', { vapidPublicKey: '${validPublicKey}', appKey: '${appKey}', token: '${token}', workerUrl: '/serviceworker.js' })`
      )
    )
    .then(() =>
      global?.[airshipVariable]
        ?.then(function (sdk) {
          d('Airship > loading > sdk.channel', sdk.channel)
          if (!sdk.channel && sdk.isSupported && sdk.canRegister) {
            return Promise.resolve()
          }
        })
        .catch(function (err) {
          d('Airship > loading > error', err)
          return Promise.reject(err)
        })
    )
    .catch(_e => {
      // fail silently
    })
}

export const askForPush = () =>
  global[airshipVariable]
    .then(sdk => sdk.register())
    .then(channel => {
      d('Airship > accepted > sdk.channel', channel)
      return Promise.resolve()
    })
    .catch(e => {
      console.log('Airship > refused from prompt', e)
    })
